<mat-card-footer>
  <mat-progress-bar
    mode="indeterminate"
    *ngIf="isLoading; else placeholder"
  ></mat-progress-bar>
  <ng-template #placeholder
    ><div class="progress-bar-height"></div
  ></ng-template>
</mat-card-footer>
